import {useState} from 'react';
import {Button} from '@mui/material';

import AddSingleNewPrice from './AddSingleNewPrice';
import AddPriceCSVUpload from './AddPriceCSVUpload';
import PricingListCommonWrapperModalComponent from '../PricingListCommonWrapperModalComponent';

import {PrincingListFormikFormType} from '../PricingList';

import {ADD_NEW_PRICE_TYPES, PRICE_COMPONENT_MODES} from './constants';

import {BarChartSquarePurpleIcon} from '~/assets/svgs';

interface INewPriceComponentProps {
  isModalOpen: boolean;
  handleCloseClick: () => void;
  formik: PrincingListFormikFormType;
}

type TAddPriceType =
  (typeof ADD_NEW_PRICE_TYPES)[keyof typeof ADD_NEW_PRICE_TYPES];

const NewPriceComponent: React.FC<INewPriceComponentProps> = ({
  isModalOpen,
  handleCloseClick,
  formik,
}) => {
  const [addPriceType, setAddPriceType] = useState<TAddPriceType | undefined>(
    undefined
  );

  const handleAddNewPriceType = (type: TAddPriceType) => {
    setAddPriceType(type);
  };

  const shouldShowCancelButton = addPriceType && formik.values.categoryId;
  const isSaveDisabled =
    !formik.values.categoryId || formik.isSubmitting || !formik.isValid;

  return (
    <div className="max-h-[70vh] overflow-y-auto pr-2 space-y-4">
      {isModalOpen && (
        <PricingListCommonWrapperModalComponent
          isOpen={isModalOpen}
          onClose={handleCloseClick}
          title={addPriceType ? 'Add a new price' : 'New price'}
          headerIcon={<BarChartSquarePurpleIcon />}
          onPrimaryClick={formik.handleSubmit}
          primaryButtonTitle="Save"
          isPrimaryDisabled={isSaveDisabled}
          isPrimaryVisible={!!addPriceType}
          isSecondaryVisible={shouldShowCancelButton}
          secondaryButtonTitle="Cancel"
          onSecondaryClick={handleCloseClick}
        >
          <div className="space-y-4">
            {addPriceType === ADD_NEW_PRICE_TYPES.ADD_NEW_PRICE ? (
              <AddSingleNewPrice
                formik={formik}
                mode={PRICE_COMPONENT_MODES.ADD_PRICE_MODE}
              />
            ) : addPriceType === ADD_NEW_PRICE_TYPES.UPLOAD_CSV ? (
              <AddPriceCSVUpload />
            ) : (
              <>
                <Button
                  variant="outlined"
                  onClick={() =>
                    handleAddNewPriceType(ADD_NEW_PRICE_TYPES.ADD_NEW_PRICE)
                  }
                  className="w-96 h-16 rounded-xl border border-[var(--color-grey-7)] shadow-[0px_4px_8px_4px_#10182805] text-base font-bold text-gray-900 flex items-center justify-start px-6 hover:bg-gray-50 normal-case"
                >
                  Add a new price
                </Button>
                <Button
                  variant="outlined"
                  onClick={() =>
                    handleAddNewPriceType(ADD_NEW_PRICE_TYPES.UPLOAD_CSV)
                  }
                  className="w-96 h-16 rounded-xl border border-[var(--color-grey-7)] shadow-[0px_4px_8px_4px_#10182805] text-base font-bold text-gray-900 flex items-center justify-start px-6 hover:bg-gray-50 normal-case"
                  disabled={true}
                >
                  Upload CSV file
                </Button>
              </>
            )}
          </div>
        </PricingListCommonWrapperModalComponent>
      )}
    </div>
  );
};

export default NewPriceComponent;
